import { useSyncExternalStore } from 'react';

function subscribe(onChange) {
  const observer = new ResizeObserver(onChange);
  observer.observe(document.getElementById('main'));
  return () => observer.disconnect();
}

// Use the same available page width as the theme's container queries.
export default function useDesktopLayout() {
  return useSyncExternalStore(
    subscribe,
    () => document.getElementById('main').clientWidth >= 992,
    () => false,
  );
}
